import axios from 'axios';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const RATE = 16000;

// Browser recordings (webm/opus, Safari mp4) are not always decodable by Whisper, so send 16 kHz mono WAV.
const toWav = async (blob) => {
  const Ctx = window.AudioContext || window.webkitAudioContext;
  const ctx = new Ctx();
  try {
    const decoded = await ctx.decodeAudioData(await blob.arrayBuffer());
    const frames = Math.ceil(decoded.duration * RATE);
    const off = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, frames, RATE);
    const src = off.createBufferSource();
    src.buffer = decoded;
    src.connect(off.destination);
    src.start();
    const pcm = (await off.startRendering()).getChannelData(0);
    const view = new DataView(new ArrayBuffer(44 + pcm.length * 2));
    const str = (o, s) => [...s].forEach((c, i) => view.setUint8(o + i, c.charCodeAt(0)));
    str(0, 'RIFF'); view.setUint32(4, 36 + pcm.length * 2, true); str(8, 'WAVE'); str(12, 'fmt ');
    view.setUint32(16, 16, true); view.setUint16(20, 1, true); view.setUint16(22, 1, true);
    view.setUint32(24, RATE, true); view.setUint32(28, RATE * 2, true); view.setUint16(32, 2, true); view.setUint16(34, 16, true);
    str(36, 'data'); view.setUint32(40, pcm.length * 2, true);
    for (let i = 0; i < pcm.length; i += 1) view.setInt16(44 + i * 2, Math.max(-1, Math.min(1, pcm[i])) * 0x7fff, true);
    return new Blob([view], { type: 'audio/wav' });
  } finally {
    ctx.close().catch(() => {});
  }
};

export const transcribeBlob = async (blob, name = 'dictation') => {
  let file = blob;
  try { file = await toWav(blob); } catch { file = blob; }
  const ext = file.type === 'audio/wav' ? 'wav' : ((blob.type.split('/')[1] || 'webm').split(';')[0]);
  const fd = new FormData();
  fd.append('audio', file, `${name}.${ext}`);
  const r = await axios.post(`${BACKEND}/api/dictation/transcribe`, fd, { headers: { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` } });
  return r.data.transcript || '';
};

export default transcribeBlob;
